// extracted by mini-css-extract-plugin
module.exports = {"customBox":"CustomBox_customBox__2-v6Q","header":"CustomBox_header__1DIrZ","body":"CustomBox_body__1-nfJ","footer":"CustomBox_footer__37KRw"};